import { directionForSeed } from './directionsData.js';
import type { ConversationSeed } from '@orborix/shared-types';
import type { ScenarioMission } from '../../scenarios/scenarioTypes.js';

export interface RailTopic {
  /** Rótulo chico de arriba: "ESCENA" o "TEMA". */
  kicker: 'ESCENA' | 'TEMA';
  label: string;
  /** Color del tema elegido; la escena y "Libre" van con el color por defecto. */
  color: string | null;
}

/**
 * Qué dice la casilla del panel lateral de la charla en la compu. Una escena
 * manda sobre el tema: en "En el café" no hay tema elegido, y decía "TEMA
 * Libre" como si fuera una charla suelta (prueba de la #575, 20/10).
 */
export function railTopic(
  scenarioMission: Pick<ScenarioMission, 'title'> | null,
  activeSeed: ConversationSeed | null,
): RailTopic {
  if (scenarioMission) return { kicker: 'ESCENA', label: scenarioMission.title, color: null };
  const direction = directionForSeed(activeSeed);
  return { kicker: 'TEMA', label: direction?.label ?? 'Libre', color: direction?.color ?? null };
}
